import { ItemOptions } from './cartItem';

export type CustomerPlacement = 'standard' | 'preSale' | 'backOrder';

export interface AddItem {
  variantId: number;
  quantity?: number;
  customerPlacement: CustomerPlacement;
  bundleExternalId?: string;
  options?: Partial<ItemOptions> | undefined;
}

export interface RemoveItem {
  identifier: number;
  quantity: 0;
}

export interface UpdateItem {
  identifier: number;
  quantity?: number;
  customerPlacement: CustomerPlacement;
  bundleExternalId?: string;
  options?: Partial<ItemOptions> | undefined;
}

export interface UpdateCart {
  id?: number;
  cartItems?: Array<AddItem | UpdateItem | RemoveItem>;
  couponCode?: string;
  giftOrder?: boolean;
}

export function isAddItem(object: any): object is AddItem {
  return 'variantId' in object && !('identifier' in object);
}

export function isUpdateItem(object: any): object is UpdateItem {
  return 'identifier' in object && object.quantity > 0;
}
